import {
  Box,
  Flex,
  Heading,
  Container,
  HStack,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl
} from '@chakra-ui/react'
import { FC, useEffect } from 'react'

import useParamsCenter from '@hook/config/use-params-center'
import useParametrizationMinimumBilling from '@hook/parametrization/use-mininum-billing'

import Layout from '@component/Layout'
import ParamsCenterTable from '@component/Modules/ParamsCenter/Table/Index'
import ProfilesSearcher from '@component/Modules/Profile/Searcher'
import Filter from '@component/Shared/Filter'

const ParamsCenter: FC = () => {
  const { getParamsCenter, paramsCenter } = useParamsCenter()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { filterEdit, loaddingEdit, paramsEdit, handleUpdateEditParams } =
    useParametrizationMinimumBilling()

  useEffect(() => {
    paramsCenter?.length === 0 && getParamsCenter()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout title="Centros Parametrizados" withBackdroundDrop>
      <Container maxW="container.lg" py={6}>
        <Box bg="white" p={6} borderRadius={8} boxShadow="sm">
          <Flex alignItems="center" justifyContent="space-between" mb={4}>
            <Heading size="lg">Centros Parametrizados</Heading>
            <ProfilesSearcher />

            <HStack spacing={3}>
              <Button onClick={onOpen} size="sm" colorScheme="green">
                Novo Centro
              </Button>

              <Modal isOpen={isOpen} onClose={onClose} size="2xl" isCentered>
                <ModalOverlay />
                <ModalContent background={'white'} marginX={[4, 8, 16]}>
                  <ModalHeader
                    paddingTop={2}
                    paddingBottom={2}
                    paddingLeft={4}
                    paddingRight={4}
                    textColor={'gray.200'}
                    background={'#1d5840'}
                    borderTopLeftRadius={5}
                    borderTopRightRadius={5}
                    borderBottom="3px solid #ECC94B"
                  >
                    Adicionar Centro
                  </ModalHeader>
                  <ModalCloseButton />
                  <ModalBody bg="white" pt={0} py={4}>
                    <Box pt={6}>
                      <FormControl isRequired>
                        <Filter
                          label="Empresa"
                          options={filterEdit.companies}
                          value={paramsEdit.empresa}
                          onChange={value =>
                            handleUpdateEditParams({
                              name: 'empresa',
                              value: value
                            })
                          }
                          isLoading={loaddingEdit}
                        />
                      </FormControl>
                    </Box>

                    <br></br>
                  </ModalBody>

                  <ModalFooter>
                    <Button colorScheme="blue" mr={3} onClick={onClose}>
                      Fechar
                    </Button>
                    <Button
                      colorScheme="primary"
                      textColor={'gray.200'}
                      background={'#1d5840'}
                    >
                      Adicionar
                    </Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>
            </HStack>
          </Flex>
          <ParamsCenterTable />
        </Box>
      </Container>
    </Layout>
  )
}

export default ParamsCenter
